<template>
    <div class="bg_main">
        <v-row>
            <v-col cols="12">
                <v-card v-if="proceduresStore.procedureDataForm != null && proceduresStore.procedureDataForm.api_message != 'Trámite finalizado.'">
                    <v-card-title  class="font-weight-black mobile-padding-bottom" style="color:#ff8400" v-if="proceduresStore && proceduresStore.taskSteps && proceduresStore.taskSteps[currentIndexForm]">
                        {{proceduresStore.taskSteps[currentIndexForm].formulario_nombre }}
                    </v-card-title>
                    <v-card-subtitle >
                    {{processStore.processName}} 
                    </v-card-subtitle>
                    <v-divider class="mx-6"></v-divider>
                    <v-card-text>
                        <v-container>
                            <!-- STEPPER ON HEADER -->
                            <TaskSteps :current-task="getCurrentStep()" :tramite_id="procedureMeta.tramite_id" />

                            <!-- FORM CONTENT -->
                            <Form procedure-action="execute"/>
                        </v-container>
                    </v-card-text>
                </v-card>
                <!-- <v-card v-if="proceduresStore.procedureDataForm != null">
                    <Dashboard v-if="proceduresStore.procedureDataForm.api_message == 'Trámite finalizado.' && proceduresStore.procedureDataForm.next_url == null && proceduresStore.procedureDataForm.previous_url == null " />
                </v-card> -->
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {mapActions, mapState, mapGetters} from "vuex";
    import {procedureSubmitNextRequest, procedureTaskStepsRequest} from "bestgob-core/api/models";

    import Form from '../components/Procedure/Form'
    import TaskSteps from '../components/Procedure/TaskSteps'

    import * as Storage from 'bestgob-core/core/storage.js'
    import Constants from "bestgob-core/core/constants";

    export default {
        data(){
          return {
              currentTask: 1,
              currentIndexForm: 0
          }
        },
        components: {
            Form, TaskSteps, 
        },

        computed: {
            ...mapState({proceduresStore: state => state.procedures, processStore: state => state.processes}),
            ...mapGetters('procedures', ['procedureMeta'])
        },

        mounted() {
            /**
             * Si el componente fue llamado al dar siguiente en la ventanda de Creacion o Continuar
             * Si no (el usuario esta refrescando la pantalla)
            */

            if (this.proceduresStore.executingProcedure){
                this.initScreenElements()
            }else{
                this.initLoadingFormContent()
            }
        },

        watch: {
            '$store.state.procedures.procedureDataForm'(){
                this.initScreenElements()
                try{
                    if (this.$store.state.procedures.procedureDataForm.api_message == 'Trámite finalizado.' && this.$store.state.procedures.procedureDataForm.next_url == null && this.$store.state.procedures.procedureDataForm.previous_url == null ) {
                        this.$router.push({name: 'processes'})    
                        this.$store.dispatch('alerts/success', ' La etapa de su trámite ha sido finalizada con éxito.' , {root: true});
                        this.$forceUpdate();
                    }
                }catch(error){
                    error
                }
            }
        },

        methods: {
            ...mapActions('procedures', ['createProcedure', 'getProcedureTaskSteps', 'getProcedureExecutedStep']),
            ...mapActions('processes', ['getProcessDetails']),

            /**
             * Busca la ultima URL usado para cargar el contenido del formulario para cargar todo desde cero
             * De lo contrario redireccion a la pagina de crear tramite
             */
            initLoadingFormContent(){
                let lastFormUrl = Storage.getItem(Constants.KEY_LAST_FORM_URL)
                let lastProcessExecuted = Storage.getItem(Constants.KEY_LAST_PROCESS_EXECUTED)

                if (lastFormUrl && lastProcessExecuted && lastProcessExecuted == this.$route.params.processId){
                    let request = procedureSubmitNextRequest()
                    request.processId = lastProcessExecuted
                    request.url = lastFormUrl

                    this.getProcedureExecutedStep(request)
                }else{
                    this.$router.push({name: 'procedure_create', params: {processId: this.$route.params.processId}})
                }
            },

            initScreenElements(){
                if (this.proceduresStore.procedureDataForm != null){
                    if (this.processStore.processName == null){
                        this.fetchProcessName()
                    }

                    this.fetchTaskSteps()
                }
            },

            fetchProcessName(){
                //Call from Vuex: Get process details
                this.getProcessDetails(this.procedureMeta.proceso_id)
            },

            fetchTaskSteps(){
                let request = procedureTaskStepsRequest()
                request.stageId = this.procedureMeta.etapa_id
                request.taskId = this.procedureMeta.tarea_id

                //Call from VueX: get task steps to show on Header
                this.getProcedureTaskSteps(request)
            },

            getCurrentStep(){
                let currentIndex = 0
                if (this.proceduresStore.taskSteps != null){
                    this.proceduresStore.taskSteps.forEach((step, index) => {
                        if (step.formulario_id == this.procedureMeta.formulario_id){
                            currentIndex = (index + 1)
                            return
                        }
                    })

                    if (currentIndex == 0 && this.proceduresStore.procedureDataForm.next_url != null ){
                        currentIndex = this.proceduresStore.taskSteps.length + 1
                    }
                }
                this.currentIndexForm = currentIndex-1
                return currentIndex
            }

        }
    };
</script>

<style scoped>

@media only screen and (max-width: 1000px){
    .mobile-padding-bottom{
        padding-bottom: 1rem;
    }
}

</style>
